import React from 'react';
import { FDStack } from '@facet-wealth/design';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import {
  buildUseStyles,
  useTheme,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = buildUseStyles('ProposalInflowsSectionSkeleton', (theme) => ({
  skeleton: {
    borderRadius: theme.radius.md,
  },
}));

const ProposalInflowsSectionSkeleton = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={isMobile ? 1 : 2} width={'100%'}>
      <Skeleton className={classes.skeleton} variant={'rect'} width={250} height={65} />
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={isMobile ? 350 : 120} />
      <FDStack direction={isMobile ? 'column' : 'row'} alignItems={'center'} spacing={2} width={'100%'}>
        <Skeleton className={classes.skeleton} variant={'rect'} width={isMobile ? '100%' : '60%'} height={400} />
        <Skeleton className={classes.skeleton} variant={'rect'} width={isMobile ? '100%' : '40%'} height={400} />
      </FDStack>
    </FDStack>
  );
};

ProposalInflowsSectionSkeleton.defaultProps = {};

ProposalInflowsSectionSkeleton.propTypes = {};

export { ProposalInflowsSectionSkeleton };
